export class ArrayUtils {
    public static cloneMatrix(input: any[][]): any[][] {
        const result = [];
        for (let column of input) {
            result.push([...column]);
        }

        return result;
    }

    public static isAllTrue(array: boolean[]): boolean {
        for (let value of array) {
            if (!value) {
                return false;
            }
        }
        return true;
    }

    public static shuffleArray(array: any[]): any[] {
        let a: any[] = array.concat();
        for (let i = a.length; i; i--) {
            let j = Math.floor(Math.random() * i);
            [a[i - 1], a[j]] = [a[j], a[i - 1]];
        }
        return a;
    }
}